import { haveValue } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";
import ProfileRow from "./ProfileRow";
import AccordionRow from "./AccordionRow";
import AccordionParticipantRow from "./AccordionParticipantRow";
import { aggregateApplicationData } from "../../helper/profileCalculations";
import React from "react";

const ProfileTable = ({
  profile,
  properties,
  loadData,
  user,
  openAssignLLModal,
  checkSalary,
  rentPercentage,
  rentDoc,
  tenantChecks = false,
  deaWorkspace,
}) => {
  const { _t } = useTranslator();

  return (
    <>
      <div className="upcoming-box ">
        <table className="upcoming-table landlord-table bigtable_set">
          <caption className="skor-details d-none"></caption>
          <thead className="hideOnMobile">
            <tr className="first-row">
              <th style={{ width: "25%" }}> {_t("tenant")} </th>
              <th className="skor-details-column"> {_t("skor")} </th>
              <th> {_t("income")} </th>
              <th> {_t("maxRent", "Field in profile table")} </th>
              {/* <th> {_t("flatmates")} </th> */}
              <th> {_t("members")} </th>
              <th> {_t("guarantors")} </th>
              <th> {_t("linkedProperties", "Field in profile table")} </th>
              <th style={{ width: "16%" }}>
                {" "}
                {_t("infoUpdatedAt", "Field in profile table")}{" "}
              </th>
              <th style={{ width: "2%" }}></th>
            </tr>
          </thead>

          <tbody>
            {haveValue(profile)
              ? profile.map((data) => {
                  if (data?.application_id?.participants?.length > 0) {
                    const aggregatedData = aggregateApplicationData(
                      data,
                      user,
                      _t,
                      deaWorkspace,
                      checkSalary
                    );
                    return (
                      <React.Fragment key={data._id}>
                        <AccordionRow
                          profile={data}
                          aggregatedData={aggregatedData}
                          properties={properties}
                          loadData={loadData}
                        />
                        {data.application_id.participants?.map(
                          (participant, index) => (
                            <AccordionParticipantRow
                              key={`${data._id}-participant-${index}`}
                              profile={data}
                              participant={participant}
                              isPending={
                                participant.consent_status !== "accepted"
                              }
                              isOwner={
                                participant.id ===
                                data?.application_id?.created_by
                              }
                            />
                          )
                        )}
                      </React.Fragment>
                    );
                  } else {
                    return (
                      <ProfileRow
                        key={data._id}
                        profile={data}
                        properties={properties}
                        loadData={loadData}
                        openAssignLLModal={openAssignLLModal}
                        checkSalary={checkSalary}
                        rentPercentage={rentPercentage}
                        rentDoc={rentDoc}
                        tenantChecks={tenantChecks}
                      />
                    );
                  }
                })
              : _t("noDetailsFound")}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ProfileTable;
